export const DEFAULT_PAGE_SIZE = 100;
//# sourceMappingURL=pagination.js.map